/** @module Report uncaught browser errors to the server log, so testers need not describe them. */
import { APP_VERSION } from "@/lib/app-version";
import { log } from "@/lib/client-log";

// A render loop throws the same error hundreds of times; a few lines say enough.
const PER_MINUTE = 10;
const MESSAGE_LENGTH = 300;

let sent: number[] = [];
const seen = new Set<string>();

function report(kind: string, message: string, source?: string, line?: number): void {
  const now = Date.now();
  sent = sent.filter((at) => now - at < 60_000);
  const key = `${kind}:${message}:${source ?? ""}:${line ?? ""}`;
  if (sent.length >= PER_MINUTE || seen.has(key)) return;
  seen.add(key);
  sent.push(now);
  log(
    "app.error",
    {
      kind,
      message: message.slice(0, MESSAGE_LENGTH),
      source: source ? source.slice(0, 200) : null,
      line: line ?? null,
      route: window.location.pathname,
      version: APP_VERSION,
    },
    "error",
  );
}

/** Listen once for errors nobody caught; call it at startup. */
export function reportUncaughtErrors(): void {
  window.addEventListener("error", (event) => {
    report("error", event.message || "unknown", event.filename, event.lineno);
  });
  window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    const reason: unknown = event.reason;
    report(
      "rejection",
      reason instanceof Error ? `${reason.name}: ${reason.message}` : String(reason),
    );
  });
}
